<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('addEditParution.pageParution.popUpDuplication.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline is-justify-content-center">
        <b-field
          :label="$t('addEditParution.pageParution.popUpDuplication.qteACreer')"
          class="column mgb-0 obligatoire">
          <b-input
            v-model.number="qteACreer"
            :use-html5-validation="false"
            type="number"
            min="1"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="dupliquer()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import genererGuid from '@/services/general/genererGuid';

export default {
  props: {
    items: {
      type: Array,
      require: true,
    },
    parution: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      qteACreer: 1,
    };
  },
  methods: {
    dupliquer() {
      this.items.forEach(item => {
        for (let i = 0; i < this.qteACreer; i += 1) {
          this.parution.pages.unshift(cloneDeep({
            ...item,
            id: genererGuid(),
            selected: false,
            isCreate: true,
          }));
        }
      });
      this.$parent.close();
    },
  },
};
</script>
